module.exports = __webpack_public_path__ + "img/platform_login_side.78f4cc8b.svg";